import { z } from 'zod'
import { OrganizationInfoResponse } from '@/generated'

export interface EnterpriseInformationType {
  enterpriseName: string
  seats: number
  billingAddress: BillingAddress
  phoneNumber: string
  email: string
  mailingAddress: MaillingAddress
}

const billingAddressSchema = z
  .object({
    city: z.string(),
    state: z.string(),
    address: z.string(),
    zip_code: z.number(),
  })
  .nullish()

type BillingAddress = z.infer<typeof billingAddressSchema>
type MaillingAddress = BillingAddress

export const paymentEnterpriseInformationDTO = (
  data: OrganizationInfoResponse
): EnterpriseInformationType => {
  return {
    enterpriseName: data.name,
    seats: data.seats,
    phoneNumber: data.phone_number ?? '',
    email: data.email ?? '',
    billingAddress: billingAddressSchema.safeParse(data.billing_address).data,
    mailingAddress: billingAddressSchema.safeParse(data.mailing_address).data,
  }
}
